export default "__VITE_ASSET__DQQoF3zG__"